import qs from 'qs'
import { get, post } from '@/utils/http/http'
import {
  SUBSCRIBE_URI,
  BILL_API_URL,
  SHOP_URL,
  LIVEPAY_URL,
  gwServer,
  LIVE_GW_URL,
} from '@/utils/http/baseUrl'

export function createCode(params) {
  return get(`${SUBSCRIBE_URI}/slidverify/api/v2/code/create`, params)
}

export function verifyCode(params) {
  return post(
    `${SUBSCRIBE_URI}/slidverify/api/v2/code/verify`,
    qs.stringify(params)
  )
}

export function getShopDetailInfo(params) {
  return post(`/liveajax/getshopdetailinfo`, qs.stringify(params))
}

export function payCenter(data) {
  return post('/v1/cus/pay/payCenter', data)
}

export function cancelPayOrder(data) {
  return get(LIVE_GW_URL + '/train/v1/cus/pay/cancelOrder', data)
}

export function getWaitPayOder(data) {
  return post(LIVE_GW_URL + '/train/v1/cus/pay/getWaitPayOder', data)
}

export const $orderApi = {
  // 订单列表
  getOrderList: params =>
    post(`${BILL_API_URL}/api/UserOrder/GetMyOrderList`, params),

  // 售后退款详情列表
  getPostSaleList: params =>
    post(`${BILL_API_URL}/api/UserOrder/GetPostSaleList`, params),

  // 订单详情
  getOrderData: params =>
    post(`${BILL_API_URL}/api/UserOrder/GetOrderData`, params),

  // 支付中心接口
  payShopCenter: params => post(`${SHOP_URL}/api/order/payshopcenter`, params),

  // 重新唤起
  payOrderCallNew: params => post(`${SHOP_URL}/api/order/payordercall`, params),

  // 支付轮询
  getPayState: params =>
    get(`${LIVEPAY_URL}/Assets/V1/GetPayState?orderId=${params}`, {}, false),

  // 检查是否已核销
  beforeShowverify: params =>
    post(`${SHOP_URL}/api/orderdelivery/beforeshowverify`, params),

  // 绿地定制接口
  ldorderPreparetopay: params =>
    post(`/liveajax/ldorderpreparetopay`, qs.stringify(params)),

  // 支付接口
  payOrderCall: params => post(`/liveajax/PayOrderCall`, qs.stringify(params)),

  // 检查手机授权
  checkPhoneAuth: params =>
    post(`/liveajax/checkphoneauthscenenonlive`, params),

  // 设置订单状态
  setOrderStatus: params =>
    post(`${SHOP_URL}/api/orderdelivery/setorderstatus`, params),
  setOrderStatusOld: params =>
    post(`/liveajax/SetOrderStatus`, qs.stringify(params)),

  // 提交举报信息
  isComplaint: params => post(`/live/IsComplaint`, qs.stringify(params)),

  // 提交退款申请
  refundProduct: params =>
    post(`/liveajax/refundproduct`, qs.stringify(params)),

  // 获取订单中奖机会次数
  getLotteryChance: params =>
    post(`/marketing/wx/v1/lottery/query_lottery_chance`, params, false, {
      allResolve: true,
    }),

  // 提交留言信息
  setAppraises: params => post(`/liveajax/SetAppraises`, qs.stringify(params)),

  // 获取用户地址
  getUsrusedAddr: params =>
    post(`/liveajax/getusrusedaddr`, qs.stringify(params)),

  // 获取用户地址列表
  getUsrAddr: params => post(`/liveajax/getusraddr`, qs.stringify(params)),

  // 保存用户地址
  setUsrAddr: params => post(`/liveajax/setusraddr`, qs.stringify(params)),

  // 保存用户当前使用地址
  setUsrAddrUsed: params =>
    post(`/liveajax/setusraddrused`, qs.stringify(params)),

  // 获取门店地址列表
  getSelfTakeStoreList: params =>
    post(`/liveajax/GetSelfTakeStoreList`, qs.stringify(params)),

  // 获取优惠券列表
  getShopCouponList: params =>
    post(`${SHOP_URL}/api/order/GetOrderCouponList`, params, false),

  // 获取可使用优惠券列表（优惠券算法）
  getShopUseCouponList: params =>
    post(`${SHOP_URL}/api/order/getshopusecouponinfo`, params, false),

  // 删除用户地址
  delUsrAddr: params => post(`/liveajax/delusraddr`, qs.stringify(params)),

  // 获取订单核销券信息
  getVerifyRecords: params =>
    post(`${SHOP_URL}/api/v1/wx/verify/verify_records`, params, false),

  // 提交退款申请
  getOrderSubtotal: params =>
    post(`/live/getordersubtotal`, qs.stringify(params)),

  // 订单灰度
  getGrayInfo: params =>
    get(`${BILL_API_URL}/api/UserOrder/GetGrayInfo`, params),

  postOrderAddress: params =>
    post(`${SHOP_URL}/api/orderdelivery/getorderdelivery`, params),

  postEditOrderAddress: params =>
    post(`${SHOP_URL}/api/orderdelivery/saveorderdelivery`, params),
  // 获取订单小计
  getordersubtotal: params =>
    post(`${SHOP_URL}/api/order/getordersubtotal`, params, false, {
      allRes: true,
    }),

  // 获取详情物流详情信息
  getOrderDeliveryInfo: params =>
    post(`${BILL_API_URL}/api/UserOrder/GetOrderDeliveryInfo`, params),

  // 获取商品快照
  getGoodsSnapshot: params =>
    get(`${BILL_API_URL}/api/UserOrder/GetOrderSnapshot`, params),

  // 获取商品核销状态 轮询的
  CheckOrderStatus: params =>
    post(`${BILL_API_URL}/api/UserOrder/CheckOrderStatus`, params, false),

  // 获取门店商品订单
  GetOrderUnVerifyOrderIds: params =>
    post(`${BILL_API_URL}/api/UserOrder/GetOrderUnVerifyOrderIds`, params),

  // 获取物流信息
  getorderlogisticsquery: params =>
    post(`${SHOP_URL}/api/orderdelivery/getorderlogisticsquery`, params),
  // 获取订单小计
  getAreaProductCartInfo: params =>
    post(`${SHOP_URL}/api/order/getAreaProductCartInfo`, params, false),

  // 获取可核销商品
  getCanVerifyGoods: params =>
    post(`${SHOP_URL}/api/v1/wx/verify/unverify_products`, params, false),

  // 获取使用中的收货地址
  getusrusedaddr: params => post(`/liveajax/getusrusedaddr`, params, false),
  // 获取所有收货地址
  getusraddr: params => post(`${SHOP_URL}/api/address/address`, params, false),
  // 删除收货地址
  DelUsrAddr: id => post(`/livehome/DelUsrAddr`, { id }, false),
  // 添加/编辑收货地址
  setusraddr: params =>
    post(`${SHOP_URL}/api/address/save_address`, params, false),

  // 保存收货信息（虚拟商品）
  saveAddress: params =>
    post(`${SHOP_URL}/api/address/save_address`, params, false),

  // 获取商品sku信息
  getProSku: params =>
    get(`${SHOP_URL}/api/v2/product/goods_skus`, params, false),

  // 获取单个商品信息(GoodsItem的数据)
  getGoodsItem: params =>
    get(`${SHOP_URL}/api/v2/product/product_item`, params, false),

  // 获取商品页数据
  getGoodsPage: data =>
    post(`${SHOP_URL}/api/v2/product/product_info`, data, false),

  // 新版支付中心商品下单
  gateWayPayShopCenter: params =>
    post(`${gwServer}/api/order/payshopcenter`, params, false, {
      allResolve: true,
    }),
  // 新版支付中心商品下单
  payshopcenter: (params, customHeaders) =>
    post(`${SHOP_URL}/api/order/payshopcenter`, params, false, {
      allResolve: true,
      customHeaders,
    }),

  // 获取商品订单金额
  getProductOrderSubtotal: params =>
    post(`${SHOP_URL}/api/order/GetProductOrderSubtotal`, params, false),
  // 代理部分退款校验
  validAgentCanApplyRefund: params =>
    post(`${SHOP_URL}/api/order/RefundOrderVerify`, params, false),
  // 根据订单id获取订单信息
  getUserOrderSimpleInfo: params =>
    get(`${LIVEPAY_URL}/Assets/V1/GetUserOrderSimpleInfo`, params, false),
  // 获取代理门店信息
  getOrderAgentStoreInfo: params =>
    post(`${SHOP_URL}/api/order/getorderstoreinfo`, params, false),
  // 计算商品运费
  computeProductShipping: params =>
    post(`${SHOP_URL}/api/v2/product/compute_product_shipping`, params, false),
  // 申请退款前校验
  validCanApplyRefund: params =>
    post(`${BILL_API_URL}/api/UserOrder/RefundOrderVerify`, params, false),

  // 删除订单
  deleteOrder: params =>
    post(`${BILL_API_URL}/api/UserOrder/DelMyOrder`, params, false),
}
